import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { MobileSheet } from '../../navigation/mobile/MobileSheet';
import type { BrowseUsageData } from '../hooks/useBrowseUsage';
import { browseCreditMessages as messages } from '../browseMessages';
import { BrowseCreditsSummary } from '../rail/BrowseCreditsSummary';
import { BrowseCreditsUsedUp } from '../rail/BrowseCreditsUsedUp';
import { BrowsePlanNote } from '../rail/BrowsePlanNote';
import { BrowseTrialOffer } from '../rail/BrowseTrialOffer';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowsePhone.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface BrowseCreditsSheetProps {
  usage: BrowseUsageData;
  onClose: () => void;
}

/**
 * The credits sheet of a phone (design c3). Used up: the upgrade path (or the owner or app note).
 * Else the count, the reset time and "Opened today".
 */
const BrowseCreditsSheetComponent: React.FC<BrowseCreditsSheetProps> = ({ usage, onClose }) => {
  const intl = useIntl();
  return (
    <MobileSheet id="browse-credits-sheet" title={intl.formatMessage(messages.title)} onClose={onClose}>
      <div className={styles.sheetBody}>
        {usage.left <= 0 ? (
          <BrowseCreditsUsedUp usage={usage} />
        ) : (
          <>
            <BrowseCreditsSummary usage={usage} />
            {usage.trialAvailable && <BrowseTrialOffer />}
            <BrowsePlanNote usage={usage} />
          </>
        )}
      </div>
    </MobileSheet>
  );
};

export const BrowseCreditsSheet = TypedMemo(BrowseCreditsSheetComponent);
